<template>
  <component
    :is="component"
    :handleLastStep="handleLastStep"
    :handleNextStep="handleNextStep"
    :showUserLimitWarning="showUserLimitWarning"
    :source="source"
  />
</template>

<script>
import AccountBillingFormModal from 'client/Payments/newComponents/AccountBillingFormModal.vue';
import PaymentForm from 'client/Payments/newComponents/PaymentForm.vue';
import PaymentInfoForNoCCModal from 'client/Payments/newComponents/PaymentInfoForNoCCModal.vue';
import PaymentOutroModal from 'client/Payments/newComponents/PaymentOutroModal.vue';

export default {
  name: 'PaymentModal',

  components: {
    AccountBillingFormModal,
    PaymentForm,
    PaymentInfoForNoCCModal,
    PaymentOutroModal,
  },

  props: {
    hasCreditCardOnFile: {
      type: Boolean,
      default: true,
    },
    showUserLimitWarning: {
      type: Boolean,
      default: false,
    },
    source: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      component: null,
      componentsByStep: null,
    };
  },

  mounted() {
    if (!this.hasCreditCardOnFile) {
      this.componentsByStep = ['PaymentInfoForNoCCModal', 'AccountBillingFormModal', 'PaymentOutroModal'];
    } else {
      this.componentsByStep = ['PaymentForm', 'PaymentOutroModal'];
    }
    ([this.component] = this.componentsByStep);
  },

  methods: {
    handleLastStep() {
      const stepIndex = this.componentsByStep.indexOf(this.component);
      if (stepIndex > 0) {
        this.component = this.componentsByStep[stepIndex - 1];
      }
    },

    handleNextStep() {
      const stepIndex = this.componentsByStep.indexOf(this.component);
      if (stepIndex < this.componentsByStep.length - 1) {
        this.component = this.componentsByStep[stepIndex + 1];
      }
    },
  },

};
</script>
